import { EmpathizeLayout, EmpathizeLayoutItem } from '../../../models';
import { EMPATHIZE_ACTIONS_KEYS, EMPATHIZE_GETTERS_KEYS, EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeAction, EmpathizeContext } from '../empathize.interfaces';

export class MoveSelectedAction implements EmpathizeAction {
  private context: EmpathizeContext;

  actions = {
    [EMPATHIZE_ACTIONS_KEYS.clearSelectedIndex]: (context: EmpathizeContext) => {
      this.context = context;
      context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, 0);
      context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: 0, y: 0 });
    },
    [EMPATHIZE_ACTIONS_KEYS.increaseSelectedIndexX]: (context: EmpathizeContext) => {
      this.context = context;
      if (context.state.selectedIndex > -1) {
        const newSelectedIndex = context.state.selectedIndex + 1;
        const elementsNumber = this.increaseSelectedElementX();
        if (newSelectedIndex >= elementsNumber) {
          context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, 0);
        }
      }
    },
    [EMPATHIZE_ACTIONS_KEYS.decreaseSelectedIndexX]: (context: EmpathizeContext) => {
      this.context = context;
      if (context.state.selectedIndex > -1) {
        const newSelectedIndex = context.state.selectedIndex + 1;
        const elementsNumber = this.decreaseSelectedElementX();
        if (newSelectedIndex >= elementsNumber) {
          context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, 0);
        }
      }
    },
    [EMPATHIZE_ACTIONS_KEYS.increaseSelectedIndexY]: (context: EmpathizeContext) => {
      this.context = context;
      const newSelectedIndex = context.state.selectedIndex + 1;
      if (newSelectedIndex >= -1) {
        if (newSelectedIndex >= this.getElementsNumber()) {
          this.increaseSelectedElementY();
          context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, 0);
        } else {
          context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, newSelectedIndex);
        }
      }
    },
    [EMPATHIZE_ACTIONS_KEYS.decreaseSelectedIndexY]: (context: EmpathizeContext) => {
      this.context = context;
      if (context.state.selectedIndex > 0) {
        const newSelectedIndex = context.state.selectedIndex - 1;
        context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, newSelectedIndex);
      } else if (this.decreaseSelectedElementY()) {
        context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, this.getElementsNumber() - 1);
      }
    }
  };

  private get x(): number {
    return this.context.state.selectedEmpathizeBlock.x;
  }

  private get y(): number {
    return this.context.state.selectedEmpathizeBlock.y;
  }

  private getElementsNumber(offsetX: number = 0, offsetY: number = 0): number {
    const layout: EmpathizeLayout = this.context.getters[EMPATHIZE_GETTERS_KEYS.layout];
    const layoutRow: EmpathizeLayoutItem[] = layout[this.y + offsetY];
    if (!layoutRow) {
      return 0;
    }
    const layoutItem: EmpathizeLayoutItem = layoutRow[this.x + offsetX];
    if (!layoutItem) {
      return 0;
    }
    const elements: any[] = this.context.rootGetters[layoutItem.getter];
    if (!elements) {
      return 0;
    }
    return elements.length;
  }

  private increaseSelectedElementY(): number {
    if (this.getElementsNumber(0, 1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { y: this.y + 1 });
    } else if (this.getElementsNumber(1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: this.x + 1 });
    } else {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: 0, y: 0 });
    }
    return this.getElementsNumber();
  }

  private decreaseSelectedElementY(): number {
    if (this.y === 0 && this.x === 0) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedIndex, -1);
      return 0;
    }
    if (this.getElementsNumber(0, -1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { y: this.y - 1 });
    } else if (this.getElementsNumber(-1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: this.x - 1 });
    } else {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: 0, y: 0 });
    }
    return this.getElementsNumber();
  }

  private increaseSelectedElementX(): number {
    if (this.getElementsNumber(1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: this.x + 1 });
    } else if (this.getElementsNumber(0, 1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { y: this.y + 1 });
    } else {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: 0, y: 0 });
    }
    return this.getElementsNumber();
  }

  private decreaseSelectedElementX(): number {
    if (this.getElementsNumber(-1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: this.x - 1 });
    } else if (this.getElementsNumber(0, -1)) {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { y: this.y - 1 });
    } else {
      this.context.commit(EMPATHIZE_MUTATIONS_KEYS.setSelectedEmpathizeBlock, { x: 0, y: 0 });
    }
    return this.getElementsNumber();
  }
}
